import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import CloseButton from '../../buttons/closeButton/closeButton';
import PanelContext from '../panel/panelContext';
import { PANEL_CLOSE_BUTTON_CLASS } from '../../../constants';

export default function PanelCloseButton({ children }) {
  const { closePanel, getId } = useContext(PanelContext);
  const id = `close-button-${getId()}`;
  return (
    <CloseButton
      className={PANEL_CLOSE_BUTTON_CLASS}
      onClick={() => closePanel()}
      id={id}
    >
      {children}
    </CloseButton>
  );
}

PanelCloseButton.propTypes = {
  children: PropTypes.node,
};

PanelCloseButton.defaultProps = {
  children: undefined,
};
